import React from "react";
import { Button } from "@/components/ui/button";
import { Link, useLocation, useParams } from "react-router-dom";
import { getAllMenu } from "@/api/new-api/staff-management/menu-manage/menu";
import { useEffect } from "react";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import { essentialMenuItem } from "@/components/lib/SidebarLinks";
import PathMap from "@/components/lib/PathMap";

function EssentialLayout({ children, paths = [], pageName = [] }) {
  const { id } = useParams();
  // useEffect(()=>{
  //   const fetchMenu = async()=>{
  //     try {
  //       const res = await getAllMenu()
  //       console.log(res)
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }
  // }, [])

  return (
    <div className="w-full">
      <PathMap
        pageName={{ title: "Manage Essential" }}
        paths={[
          { name: "home", path: "/home" },
          { name: "Back Office", path: "/backoffice/overview" },
          { name: "Menu Management", path: "/backoffice/menu/drinks" },
          { name: "Manage Essential", path: "/backoffice/menu/essentail-menu" },
        ]}
      />
      <div className="h-full container px-4 py-2 mt-5">
        <div className="flex flex-wrap gap-4 items-center">
          {essentialMenuItem?.map((item, val) => {
            return (
              <Link key={val} to={`${item?.path}/${item?.id}`}>
                <Button
                  className={`${
                    item?.id == id ? " " : "bg-cblack7 text-cwhite"
                  }`}
                >
                  {item.title}
                </Button>
              </Link>
            );
          })}
        </div>
        <div className="mt-5">{children}</div>
      </div>
    </div>
  );
}

export default EssentialLayout;
